export default __webpack_public_path__ + "static/el_burro_heights_meth_lab-1e854612fd25fe65cb5b86a66237547a.png";